import { AssetTreeItem } from '../../model/asset-tree-node.model';

export function getUniqueUIName(asset: AssetTreeItem): string {
  const name = asset.name;

  if (asset.level === 1) {
    return name || '';
  }
  return `${asset.code} - ${name}`;
}

export function getUniqueUICode(asset: AssetTreeItem): string {
  if (asset.level === 1) {
    return '';
  }
  return asset.code || '';
}

export function getUniqueModelName(asset: AssetTreeItem): string {
  return `${asset.id}`;
}

export function getAssetPath(asset: AssetTreeItem): string {
  return `topic-level-${asset.level}.${asset.id}`;
}
